import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import * as i1 from '@upr-web-primer/gds-poi-filter';
import { isEmpty, filter, intersection, includes } from 'lodash-es';

class GdsRelatedTileModule {
}
GdsRelatedTileModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsRelatedTileModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsRelatedTileModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsRelatedTileModule });
GdsRelatedTileModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsRelatedTileModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsRelatedTileModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class GdsRelatedTilesService {
    constructor(poiFilter) {
        this.poiFilter = poiFilter;
    }
    getRelatedTiles(pageTile, tiles, interest) {
        if (isEmpty(tiles) || !pageTile) {
            return [];
        }
        return filter(tiles, (tile) => this.hasRelatedProperties(pageTile, tile, 'AttractionExperiences') &&
            this.hasRelatedProperties(pageTile, tile, 'AttractionLocations') &&
            (interest
                ? this.hasAttribute(tile, 'AttractionInterests', interest)
                : true));
    }
    hasRelatedProperties(pageTile, tile, property) {
        const criteriaKey = this.poiFilter.getTileKeys(pageTile, property);
        const tileKey = this.poiFilter.getTileKeys(tile, property);
        if (!criteriaKey && !tileKey) {
            return true;
        }
        return intersection(criteriaKey, tileKey).length > 0;
    }
    hasAttribute(tile, property, condition) {
        return includes(this.poiFilter.getTileKeys(tile, property), condition);
    }
}
GdsRelatedTilesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsRelatedTilesService, deps: [{ token: i1.GdsPoiFilterService }], target: i0.ɵɵFactoryTarget.Injectable });
GdsRelatedTilesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsRelatedTilesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsRelatedTilesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.GdsPoiFilterService }]; } });

export { GdsRelatedTileModule, GdsRelatedTilesService };
